import React from "react";

type AuthStatusValue = {
  /** True after Keycloak init settled (success or public-path soft-fail). */
  authReady: boolean;
};

const AuthStatusContext = React.createContext<AuthStatusValue>({ authReady: false });

export function AuthStatusProvider({
  authReady,
  children,
}: {
  authReady: boolean;
  children: React.ReactNode;
}) {
  const value = React.useMemo(() => ({ authReady }), [authReady]);
  return <AuthStatusContext.Provider value={value}>{children}</AuthStatusContext.Provider>;
}

export function useAuthStatus(): AuthStatusValue {
  return React.useContext(AuthStatusContext);
}
